import { currencyFromSymbol } from 'shared/currency-utilities'
import { PriceToPay } from './PriceToPay'
import { RateCurrency } from 'booking/components/utilities'

const EditBookingPriceBreakdown = ({
    rate,
    rateCurrencySymbol,
    oldPrice,
    newPrice,
    editedReservationNewTotalPrice,
    amendmentFee,
    isModal,
}) => {
    const rowStyles = `${isModal ? 'mb-0' : 'mb-3'} d-flex align-items-baseline justify-content-sm-end ${
        isModal && 'justify-content-between justify-content-sm-between'
    }`

    return (
        <>
            <div className={rowStyles}>
                <span>
                    <T>price.breakdown.old.price</T>
                </span>
                <span className="ml-2">
                    <RateCurrency rate={rate} value={oldPrice} currency={currencyFromSymbol(rateCurrencySymbol)} />
                </span>
            </div>
            <div className={rowStyles}>
                <span>
                    <T>price.breakdown.new.price</T>
                </span>
                <span className="ml-2">
                    <RateCurrency rate={rate} value={newPrice} currency={currencyFromSymbol(rateCurrencySymbol)} />
                </span>
            </div>
            <div className={rowStyles}>
                <span>
                    <T>booking.amendment.fee.label</T>
                </span>
                <span className="ml-2">
                    <RateCurrency rate={rate} value={amendmentFee} currency={currencyFromSymbol(rateCurrencySymbol)} />
                </span>
            </div>
            <PriceToPay
                rate={rate}
                label={editedReservationNewTotalPrice.label}
                total={editedReservationNewTotalPrice.amount}
                rateCurrencySymbol={rateCurrencySymbol}
                rowStyles={rowStyles}
            />
        </>
    )
}
export default EditBookingPriceBreakdown
